import React, { useEffect, useState } from 'react';
import { find, range, isEmpty } from 'lodash';
import { injectIntl } from 'react-intl';
import { Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Select, Input, DatePicker, Checkbox } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-light-svg-icons';

import moment from 'moment';
import CustomFields from '../../components/newPatient/customFields/customFields';
import { getPacientesProfesiones, getPacientesGrupos }
from '../../../../state/actions/creators/pacientes.actioncreator';
import ModalClient from './modalClient';
import { requireAcompanyanteRule } from './rules';
import ReadOnly from '../../../shared/components/dataEntry/ReadOnly';
import { Flex } from '../../../shared/components';

const { Option } = Select;

interface addInfoProps{
  camposDinamicos: any,
  intl:any,
  hookForms:any,
  handleChange:any,
  watch:boolean,
}

function AddInfo({
  camposDinamicos, intl, hookForms, handleChange, watch,
}:addInfoProps) {
  const {
    control, setValue, errors, register,
  } = hookForms;

  const dispatch = useDispatch();
  const profesiones = useSelector((state: any) => state.pacientesWorkspace.profesiones);
  const grupos = useSelector((state: any) => state.pacientesWorkspace.grupos_cliente);
  const pacienteSelected = useSelector((state: any) => state.pacientesWorkspace.pacienteSelected);
  const anyo_nacimiento_ult_hijo = pacienteSelected?.anyo_nacimiento_ult_hijo;
  const [modalClient, setmodalClient] = useState(false);
  const [modalType, setModalType] = useState('');
  const [payClient, setPayClient] = useState<any>({});
  const [companion, setCompanion] = useState<any>({});
  const [isOpen, setIsOpen] = useState(false);
  const [hijosMenores, setHijosMenores] = useState(anyo_nacimiento_ult_hijo ? true : false);

  useEffect(() => {
    dispatch(getPacientesProfesiones());
    dispatch(getPacientesGrupos());
  }, []);

  useEffect(() => {
    if (!isEmpty(payClient)) {
      setValue('cod_paciente_pagador', payClient.id);
      setValue('nombre_paciente_pagador', payClient.nombre_completo);
    }
  }, [payClient]);

  useEffect(() => {
    if (!isEmpty(companion)) {
      setValue('cod_paciente_acompanante', companion.id);
      setValue('nombre_paciente_acompanante', companion.nombre_completo);
    }
  }, [companion]);

  useEffect(() => {
    if (pacienteSelected) {
      const {
        tiene_hijos_menores_quince, str_profesion, cod_profesion, cod_grupo_cliente, exento_iva, cod_paciente_pagador,
        cod_paciente_acompanante, nombre_paciente_pagador, nombre_paciente_acompanante, anyo_nacimiento_ult_hijo,
      } = pacienteSelected;

      // setValue('tiene_hijos_menores_quince', tiene_hijos_menores_quince);
      setValue('profesion_id', cod_profesion);
      setValue('cod_grupo_cliente', cod_grupo_cliente);
      setValue('exento_iva', exento_iva);
      setValue('cod_paciente_pagador', cod_paciente_pagador);
      setValue('nombre_paciente_pagador', nombre_paciente_pagador);
      setValue('cod_paciente_acompanante', cod_paciente_acompanante);
      setValue('nombre_paciente_acompanante', nombre_paciente_acompanante);
      setValue('anyo_nacimiento_ult_hijo', anyo_nacimiento_ult_hijo ? moment(anyo_nacimiento_ult_hijo) : null);
    }
  }, [pacienteSelected]);

  const isHidden = (field: string) => {
    const campoPersonalizado = find(camposDinamicos,
      (campoPersonalizado: any) => campoPersonalizado.campo_descripcion === field);
    if (!campoPersonalizado) return false;
    return !campoPersonalizado.propiedades.visible;
  };
  const tieneHijosMenores = () => {
    if(hijosMenores){
      setHijosMenores(false);
      handleChange('anyo_nacimiento_ult_hijo', null)
    }else{
      setHijosMenores(true);
    }
  } 
  const disabledDate = (current:any) => moment().add(-15, 'years') > current || moment() < current;
  return (
    <>
      <div className="bodyInfo flexCol">
        <div className="inputMarginTop">
          <h3>{intl.formatMessage({ id: 'pacientes.generic.titles.add_info' })}</h3>
          <div className="marginTop24">
              {!isHidden('tiene_hijos_menores_quince') && (
              <Flex flexDirection="row">
                <Flex flexDirection="column" pr="16px">
                  <p>{intl.formatMessage({ id: 'pacientes.generic.titles.tiene_hijos_checkbox' })}</p>
                  <div className="inputMarginTop">
                    <Checkbox defaultChecked={anyo_nacimiento_ult_hijo} disabled={watch} onChange={tieneHijosMenores}></Checkbox>
                  </div>
                </Flex>
                <Flex flexDirection="column" pl="16px">                
                    <p>{intl.formatMessage({ id: 'pacientes.generic.titles.fnacimiento_hijos' })}</p>
                  <div className="inputMarginTop">                
                    <Input.Group>
                      <Controller
                        name="anyo_nacimiento_ult_hijo"
                        render={
                          ({
                            name, onChange, value,
                          }) => (
                            <ReadOnly condition={!hijosMenores}>
                            <DatePicker
                              className={`${watch ? 'disabledText' : ''}`}
                              onChange={(value:any) => handleChange(name, moment(value))}
                              getCalendarContainer={(trigger: Element): any => (trigger.parentElement
                                ? trigger.parentElement : null)}
                              onPanelChange={(value:any) => {
                                if (!disabledDate(moment(value))) {
                                  handleChange(name, moment(value));
                                  setIsOpen(false);
                                } else {
                                  handleChange(name, null);
                                  setIsOpen(true);
                                }
                              }}
                              open={isOpen}
                              onOpenChange={(status) => {
                                if (status) {
                                  setIsOpen(true);
                                } else {
                                  setIsOpen(false);
                                }
                              }}
                              style={{ width: '100%' }}
                              format="YYYY"
                              placeholder={hijosMenores ? ((new Date()).getFullYear() - 1).toString() : ''}
                              disabled={watch}
                              disabledDate={disabledDate}
                              value={(hijosMenores) ? value : ''}
                              mode="year"
                            />
                            </ReadOnly>
                          )}
                        control={control}
                      />
                    </Input.Group>
                  </div>
                  </Flex>
              </Flex>
              )}

              {/* {!isHidden('profesion_id') && (
              <div className="flexCol">
                <p>{intl.formatMessage({ id: 'pacientes.generic.titles.cod_profesion' })}</p>
                <div className="inputMarginTop">
                  <Input.Group>
                    <Controller
                      name="profesion_id"
                      control={control}
                      render={
                        ({
                          name, value,
                        }) => (
                      <Select
                        getPopupContainer={(trigger:HTMLElement): any => (trigger.parentElement
                        ? trigger.parentElement : null)}
                        style={{ width: '100%' }}
                        value={value ? parseInt(value) : null}
                        onSelect={(value:any) => handleChange(name, value)}
                        placeholder={intl.formatMessage({ id: 'pacientes.new_client.select_profession' })}
                      >
                        {profesiones.map((profesion:any) => (
                        <Option key={profesion.id} value={profesion.id}>
                          {profesion.nombre}
                        </Option>
                      ))}
                      </Select>
                      )}
                    />
                  </Input.Group>
                </div>
              </div>
              )} */}
          </div>
          <div className="contact">
            {!isHidden('cod_grupo_cliente') && (
            <div className="flexCol">
              <p>{intl.formatMessage({ id: 'pacientes.generic.titles.cod_grupo_cliente' })}</p>
              <div className="inputMarginTop">
                <Input.Group>
                  <Controller
                    name="cod_grupo_cliente"
                    control={control}
                    render={
                      ({
                        name, value,
                      }) => (
                        <Select
                          className={`${watch ? 'disabledText' : ''}`}
                          disabled={watch}
                          getPopupContainer={(trigger:HTMLElement): any => (trigger.parentElement
                            ? trigger.parentElement : null)}
                          onSelect={(value: any) => handleChange(name, value)
                      }
                          placeholder={intl.formatMessage({ id: 'pacientes.new_client.group_select' })}
                          style={{ width: '100%' }}
                          value={value}
                        >
                          {grupos.map((grupo:any) => <Option key={grupo.id} value={grupo.id}>{grupo.nombre}</Option>)}
                        </Select>
                      )}
                  />
                </Input.Group>
              </div>
            </div>
            )}
            {!isHidden('cod_paciente_pagador') && (
            <div className="flexCol">
              <p>{intl.formatMessage({ id: 'pacientes.generic.titles.cod_paciente_pagador' })}</p>
              <div className="inputMarginTop" onClick={() => { !watch && setmodalClient(true); !watch && setModalType('payClient'); }}>
                <Controller
                  as={ ({name, value}) => (
                    <ReadOnly condition={watch}>
                      <Input
                        addonAfter={<FontAwesomeIcon icon={faUser} />}
                        style={{ width: '100%' }}
                        className="payClient"
                        disabled
                        value={value}
                      />
                    </ReadOnly>
              )}
                  name="nombre_paciente_pagador"
                  control={control}
                />
              </div>
            </div>
            )}
          </div>
          <div className="contact">
            {!isHidden('exento_iva') && (
            <div className="flexCol">
              <p>{intl.formatMessage({ id: 'pacientes.generic.titles.exento_iva' })}</p>
              <div className="inputMarginTop">
                <Input.Group>
                  <Controller
                    name="exento_iva"
                    control={control}
                    render={
                    ({
                      name, value,
                    }) => (
                      <Select
                        className={`${watch ? 'disabledText' : ''}`}
                        getPopupContainer={(trigger:HTMLElement): any => (trigger.parentElement
                          ? trigger.parentElement : null)}
                        style={{ width: '100%' }}
                        onSelect={(value: any) => handleChange(name, value)}
                        placeholder={intl.formatMessage({ id: 'pacientes.new_client.select_option' })}
                        value={value}
                        disabled={watch}
                      >
                        <Option value={0}>{intl.formatMessage({ id: 'pacientes.new_client.not_exempt' })}</Option>
                        <Option value={1}>{intl.formatMessage({ id: 'pacientes.new_client.exempt' })}</Option>
                      </Select>
                    )}
                  />
                </Input.Group>
              </div>
            </div>
            )}
            {!isHidden('acompanyante') && (
            <div className="flexCol">
              <p>{intl.formatMessage({ id: 'pacientes.generic.titles.companion' })}</p>
              <div className="inputMarginTop" onClick={() => { !watch && setmodalClient(true); !watch && setModalType('companion'); }}>
                <Controller
                  render={
                    ({
                      name, value,
                    }) => (
                      <ReadOnly condition={watch}>
                        <Input
                          addonAfter={<FontAwesomeIcon icon={faUser} />}
                          style={{ width: '100%' }}
                          className="payClient"
                          value={value}
                          disabled
                        />
                      </ReadOnly>
                    )}
                  name="nombre_paciente_acompanante"
                  control={control}
                />
                <div>
                  {errors.cod_paciente_acompanante && (
                    <p className="errors inputMarginTop">{errors.cod_paciente_acompanante.message}</p>
                  )}
                </div>
              </div>
            </div>
            )}
          </div>

          <CustomFields
            hookForms={hookForms}
            fields={camposDinamicos}
            values={pacienteSelected?.campos_dinamicos}
            watch={watch}
          />
        </div>
      </div>
      <ModalClient modalType={modalType} modalClient={modalClient} setmodalClient={setmodalClient} setPayClient={setPayClient} setCompanion={setCompanion} />
    </>
  );
}

export default injectIntl(AddInfo);
